import { FC } from 'react';
import { ActivationStatus } from '../../../status';
import { OverviewTabProps } from '../types/types';

export const PendingCrmDataSource: FC<OverviewTabProps> = ({ dataSource }) => {
  return <ActivationStatus dataSource={dataSource} />;
};
